// craneCapacity.ts — Crane lift-capacity data for casting layout planning.
// Values are planning estimates for visual reference only, not certified lift data.
// Source: Liebherr LR 1300 product documentation (approximate, main boom configuration).

export const INCHES_PER_METER = 39.3701;

// Liebherr LR 1300 — 300t crawler crane
export const LR1300_CAPACITY = [
  { radiusM:  12, capacityT: 300 },
  { radiusM:  18, capacityT: 200 },
  { radiusM:  24, capacityT: 150 },
  { radiusM:  30, capacityT: 100 },
  { radiusM:  36, capacityT:  75 },
  { radiusM:  42, capacityT:  60 },
  { radiusM:  54, capacityT:  40 },
  { radiusM:  66, capacityT:  25 },
  { radiusM:  78, capacityT:  18 },
] as const;

export type CraneModel = string;

/** Returns all capacity rings with radiusIn for direct SVG use */
export function craneRings(_model: CraneModel) {
  return LR1300_CAPACITY.map(r => ({
    radiusM:   r.radiusM,
    capacityT: r.capacityT,
    radiusIn:  r.radiusM * INCHES_PER_METER,
  }));
}

/** Returns capacity in tons for a given pick radius in inches (step interpolation — returns capacity of nearest ring ≥ radius) */
export function capacityAtRadius(radiusIn: number, _model: CraneModel): number {
  const rings = craneRings('LR1300');
  for (const ring of rings) {
    if (radiusIn <= ring.radiusIn) return ring.capacityT;
  }
  return 0; // beyond max reach
}

/**
 * Returns up to maxRings evenly-spaced rings from the crane's full rated reach.
 * Uses the crane spec (not slab geometry) — supports external picks beyond the slab.
 */
export function filteredRings(model: CraneModel, maxRings = 3) {
  const all = craneRings(model);
  if (all.length <= maxRings) return all;
  const step = (all.length - 1) / (maxRings - 1);
  return Array.from({ length: maxRings }, (_, i) => all[Math.round(i * step)]);
}
